/**
 * Profile validation utilities
 */

interface UserProfile {
  preferredName?: string;
  familyName?: string;
  dateOfBirth?: string;
  heightCm?: number;
  measurementSystem?: string;
  metadata?: {
    onboardingCompleted?: boolean;
    [key: string]: unknown;
  };
}

/**
 * Check if user profile is complete (all onboarding fields filled)
 */
export function isProfileComplete(
  profile: UserProfile | null | undefined
): boolean {
  if (!profile) return false;

  return !!(
    profile.metadata?.onboardingCompleted &&
    profile.preferredName &&
    profile.familyName &&
    profile.dateOfBirth &&
    profile.heightCm &&
    profile.measurementSystem
  );
}
